"use client";

import { Core } from "@faire/design-tokens";
import React from "react";

import { createSVGIcon } from "../util";

/** @deprecated `@faire/slate/icons/Twitter` instead */
export const Twitter = createSVGIcon(
  <path
    d="M6.886 16.114a11.7 11.7 0 0 1-4.128 2.076.866.866 0 0 0-.04 1.613c11.87 4.866 19.407-2.746 18.265-11.01l1.922-3.985h-2.229c-2.786-3.397-10.147-3.226-8.928 4.04 0 0-3.943.704-8.985-4.26a.87.87 0 0 0-1.464.47 9.47 9.47 0 0 0 5.587 11.056Z"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
  />,
  "Twitter",
  (strictLocalize) => ({
    viewBox: "0 0 24 24",
    titleAccess: strictLocalize({
      defaultMessage: "Twitter",
      description: {
        text: "Message for screenreaders when only the icon is displayed",
      },
    }),
    fill: "none",
    color: Core.icon.default,
  })
);
